

/******************************************************
	Map
******************************************************/
import $ from 'jquery';
import GoogleMapsLoader from 'google-maps';
import IScroll from 'iscroll/build/iscroll.js';


// scroller
var myScroll;

// map info
var geocoder;
var map;
var markers = [];
var infoWindow;

var iconURL = "/NSWMealsOnWheels/markup/dist/assets/img/icons/pin.svg";
var iconActiveURL = "/NSWMealsOnWheels/markup/dist/assets/img/icons/pinActive.svg";

// data containers
var locations;
var distances = [];

// search log
var prevSearch;
var currentSearch;
var currentSearchLocation;


export default function initMap() {
    if ($("#map").length) {
        checkScrollNeeded();
        setupMap();

        $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
            checkScrollNeeded();
        });
    }
}

function checkScrollNeeded() {
    if (Foundation.MediaQuery.atLeast('large')) {
        var settings = {
            keyBindings: true,
            bounce: false,
            momentum: true,
            mouseWheel: false,
            click: true,
            scrollbars: true,
            interactiveScrollbars: true
        };
        myScroll = new IScroll('.mapScroll', settings);
    } else {
        if (myScroll) {
            myScroll.destroy();
            myScroill = null;
        }
    }
}


/******************************************************
	Location Search Event Handlers
******************************************************/
// suburb or postcode search
function setupLocationSelector() {
    $(".map__search .button").on("click keyup", function (e) {
        if (e.which == "1" || e.which == "13") {
            e.stopPropagation();
            var address = getSearchAddress();
            if (address) searchAddress(address);
        }
    });

    $(".map__search input").on("keyup", function (e) {
        if (e.which == "13") {
            var address = getSearchAddress();
            if (address) searchAddress(address);
        }
    });
}

// search radius selection
function setupRadiusSelector() {
    $(".map__distance input[name='distance']").on("change", function (e) {
        map.setZoom(getSearchRadius()[1]);
        map.setCenter(currentSearchLocation);
        findNearbyLocations(currentSearchLocation, false);
    });

    $(".map_services_input").on("change", function (e) {
        filterMarkers();
    });
}
function filterMarkers() {
    let show = markers;
    if ($("#service1").is(":checked")) {
        show = show.filter(x => x.NDIS === "True");
    }
    if ($("#service2").is(":checked")) {
        show = show.filter(x => x.NDISSelfManaged === "True");
    }
    if ($("#service3").is(":checked")) {
        show = show.filter(x => x.CHSP === "True");
    }
    if ($("#service4").is(":checked")) {
        show = show.filter(x => x.FullFeeMeals === "True");
    }
    if ($("#service5").is(":checked")) {
        show = show.filter(x => x.HCP === "True");
    }
    for (var i = 0; i < markers.length; i++) {
        markers[i].marker.setMap(null);
    }
    for (var i = 0; i < show.length; i++) {
        show[i].marker.setMap(map);
    }

    findNearbyLocations(currentSearchLocation, true);
}

// start the search process
function searchAddress(address) {
    if (address == currentSearch) {
        // no change so just re-center the map
        map.setCenter(currentSearchLocation);
    } else {
        // find suburb or postcode
     
            if (Number.isInteger(parseInt(address))) {
                address = "Postcode " + address + " NSW"; 
            }
            else {
                address = address + " NSW"; 
            }

        geocoder.geocode({ 'address': address + " NSW" }, function (results, status) {
            if (status === 'OK') {
                // log the current search
                currentSearch = address;
                currentSearchLocation = results[0].geometry.location;

                // center the map
                map.setCenter(currentSearchLocation);

                // find locations within search radius
                findNearbyLocations(currentSearchLocation, true);
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
}


/******************************************************
	Init Google Map
******************************************************/
function setupMap() {
    GoogleMapsLoader.KEY = 'AIzaSyAbAcs6tXff-6uVhle2f_ke2YZ07PteRCg';
    GoogleMapsLoader.VERSION = '3.37';
    GoogleMapsLoader.LIBRARIES = ['geometry', 'places'];
    GoogleMapsLoader.LANGUAGE = 'en';
    GoogleMapsLoader.REGION = 'AU';

    GoogleMapsLoader.load(function (google) {
        geocoder = new google.maps.Geocoder({
            componentRestrictions: {
                country: 'AU',
            }
        });

        var mapOptions = {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            scaleControl: true,
            streetViewControl: false,
            zoomControl: true,
            keyboardShortcuts: false,
            draggable: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.DEFAULT
            }
        };

        map = new google.maps.Map(document.getElementById("map"), mapOptions);
        map.setZoom(13);
        map.setCenter(new google.maps.LatLng(-33.86882, 151.209296));

        // create an infoWindow object
        infoWindow = new google.maps.InfoWindow();

        // create the locations
        createLocations();

        // Fired when the map becomes idle after panning or zooming.
        google.maps.event.addListener(map, 'idle', function () {
            showVisibleMarkers();
        });

        // remove card highlighing on infoWindow close
        google.maps.event.addListener(infoWindow, 'closeclick', function () {
            $(".mapInfo.highlight").removeClass("highlight");
            resetMarkerIcons();
        });

        // setup the search functions
        setupLocationSelector();
        setupRadiusSelector();
    });
}

// add location markers to the map
function addGoogleMarker(latitude, longitude, title, address, phone, preferredEmail, website, menu, serviceIcons, index, obj) {
    var zoom = 13;

    // Create Marker object
    var point = new google.maps.LatLng(latitude, longitude);
    var marker = new google.maps.Marker({
        map: map,
        position: point,
        title: title,
        icon: iconURL,
        cardClass: "mapInfo--" + index
    });

    // Register click event
    google.maps.event.addListener(marker, 'click', function () {
        // highlight marker icon
        resetMarkerIcons();
        marker.setIcon(iconActiveURL);

        // position map
        var oZoom = map.getZoom();
        map.setCenter(point);

        if (oZoom !== zoom) {
            map.setZoom(zoom);
        }

        // populate the infoWindow
        var websiteDetails = (!website) ? "" : "<a target=\"_blank\" href=" + website + ">Visit website</a> <br/>";
        var menuDetails = (!menu) ? "" : "<a target=\"_blank\" href=" + menu + ">Download menu</a>";
        var serviceIconsDetails = (!serviceIcons) ? "" : "<div>" + serviceIcons + "</div>";
        var prefferedEmail = "";

        if (location.alternateEmail != "") {
            prefferedEmail = location.alternateEmail;
        }
        else {
            prefferedEmail = location.email;
        }

        infoWindow.setContent("<div class='gmMarker'><div class='gmMarker__title'>" + title + "</div><div class='gmMarker__content'>" + address + "<br/>Phone: " + phone + "<br/><a href=mailto:" + preferredEmail + ">Send email</a> <br/>" + websiteDetails + menuDetails + "</div></div>");
        infoWindow.open(map, this);

        $(".mapInfo.highlight").removeClass("highlight");
        $("." + marker.cardClass).addClass("highlight");
    });

    // Keep a list of markers
    markers.push({
        marker: marker,
        CHSP: obj.CHSP,
        FullFeeMeals: obj.FullFeeMeals,
        HCP: obj.HCP,
        NDIS: obj.NDIS,
        NDISSelfManaged: obj.NDISSelfManaged
    });
}

// create location markers
function createLocations() {
    $.getJSON("/Find-a-meal?locations=json", function (data) {
        if (data.locations.length) {
            // save location data
            locations = data.locations;

            // create location markers
            $.each(data.locations, function (index, value) {
                var chosenEmail = "";

                if (value.alternateEmail != "") {
                    chosenEmail = value.alternateEmail;
                } else {
                    chosenEmail = value.email;
                }

                addGoogleMarker(value.lat, value.lng, value.title, value.address, value.phone, chosenEmail, value.website, value.menu, value.serviceIcons, index, value);
            });

            // perform the initial search
            searchAddress("2000");
        }
    });
}

// find location within search radius - using haversine formula
function findNearbyLocations(center, zoom) {
    // reset marker status
    infoWindow.close();
    resetMarkerIcons();

    // only calculate if search has changed
    if (currentSearch != prevSearch) {
        var lat = center.lat();
        var lng = center.lng();
        var R = 6371; // radius of earth in km

        distances = [];

        for (var i = 0; i < markers.length; i++) {
            var mlat = markers[i].marker.position.lat();
            var mlng = markers[i].marker.position.lng();
            var dLat = rad(mlat - lat);
            var dLong = rad(mlng - lng);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;

            // only save locations in search radius
            distances.push({ index: i, distance: Math.round(d * 100) / 100 });
        }

        // sort the locations
        distances.sort(function (a, b) {
            return a.distance < b.distance ? -1 : 1;
        });

        // log search term
        prevSearch = currentSearch;
    }
    var radius = getSearchRadius()[0];

    if (zoom && distances[0].distance > radius) {
        // no results and zoom - so zoom out
        var min = distances[0].distance;
        if (min <= 5) {
            $(".map__distance input[value='5']").click();
            //goto 5
        } else if (min <= 10) {
            $(".map__distance input[value='10']").click();
            //goto 10
        } else if (min <= 20) {
            $(".map__distance input[value='20']").click();
            //goto 20
        } else if (min <= 50) {
            $(".map__distance input[value='50']").click();
            //goto 50
        } else {
            $(".map__distance input[value='0']").click();
            //go big
        }
    }
    // create the map card list with search results
    createMapList(distances);
}


/******************************************************
	Map cards
******************************************************/
// create the map card list
function createMapList(distances) {


    $(".mapInfoCards").html("");

    // only show locations in search radius
    var radius = getSearchRadius()[0];

    if (radius === 0) {
        for (var i = 0; i < distances.length; i++) {
            $(".mapInfoCards").append(buildMapCard(distances[i]));
        }
    } else {
        for (var i = 0; distances[i].distance <= radius && i < distances.length; i++) {
            $(".mapInfoCards").append(buildMapCard(distances[i]));
        }
    }

    // add event handlers
    setupMapInfoEvents();
    showVisibleMarkers();
    refreshScroller();
}

// generate map card content
function buildMapCard(item) {
    var index = item.index;
    var location = locations[index];
    var distance = item.distance;
    if ($("#service1").is(":checked") && location.NDIS !== "True") {
        return "";
    }
    if ($("#service2").is(":checked") && location.NDISSelfManaged !== "True") {
        return "";
    }
    if ($("#service3").is(":checked") && location.CHSP !== "True") {
        return "";
    }
    if ($("#service4").is(":checked") && location.FullFeeMeals !== "True") {
        return "";
    }
    if ($("#service5").is(":checked") && location.HCP !== "True") {
        return "";
    }

    var cardTitle = "<div class='mapInfo__title'>" + location.title + "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36.11 49.22' width='21.5' height='29.9'><path fill='#72dcd4' stroke='#18191d' d='M18.05.5A17.55,17.55,0,0,0,.5,18.05,19.49,19.49,0,0,0,4.27,29.58L18.05,48.37,31.83,29.58a19.5,19.5,0,0,0,3.78-11.53A17.56,17.56,0,0,0,18.05.5Z' /><g fill='#fff'><path d='M20.72,10.24a2.85,2.85,0,0,0,5.7,0,2.85,2.85,0,0,0-5.7,0m-10.87,0a2.85,2.85,0,0,0,5.7,0,2.85,2.85,0,0,0-5.7,0m15.33,4.3a9.18,9.18,0,0,0-3.9,1c.62.66.65,1.23.38,1.48l1.1-.33c4.13,7.58-4.71,15.82-4.76,15.87,16.13-6.22,14.48-18,7.18-18Zm-4.05,2.63a.61.61,0,0,0,.54-.17ZM18,32.54s-8.92-8.25-4.76-15.87l1.1.33c-.27-.27-.24-.83.38-1.48a9,9,0,0,0-3.9-1c-7.29,0-8.95,11.77,7.18,18M14.88,17.16,14.34,17a.64.64,0,0,0,.54.17' /><path d='M21.46,15.14c-2.79,1.49-3.87,3.44-8.62,4.83,8.5,5.83,12-2.07,16-2.23a1.23,1.23,0,0,1,1.35.86,4.77,4.77,0,0,0-.37-1.22,4.83,4.83,0,0,0-4.73-3.1,8.43,8.43,0,0,0-3.67.86' /><path d='M6.13,17.45a5.69,5.69,0,0,0-.36,1.15,1.23,1.23,0,0,1,1.34-.81c4.63.12,8.59,8.93,16.6,2.48a18.53,18.53,0,0,1-4.06-1.55c-1.93-1-3.34-2.48-5.19-3.37a9.27,9.27,0,0,0-3.66-.81,4.81,4.81,0,0,0-4.67,2.91' /></g></svg></div>";
    var cardContent = "<div class='mapInfo__content'>" + distance + "km - <a href='https://www.google.com/maps/dir//" + location.address + "/@" + location.lat + "," + location.lng + "' target='_blank'>Get directions</a><br />" + location.address + "<br />Phone: " + location.phone + "</div>";
    var prefferedEmail = "";

    if (location.alternateEmail != "") {
        prefferedEmail = location.alternateEmail;
    }
    else {
        prefferedEmail = location.email;
    }

    var cardLinks = "";
    var cardIcons = "";
    if (location.content || location.website || location.email || location.alternateEmail || location.menu || location.serviceIcons) {
        var email = (!prefferedEmail) ? "" : "<a href='mailto:" + prefferedEmail + "' class='mapInfo__link' target='_blank'>Send email</a>";
        var menu = (!location.menu) ? "" : "<a href='" + location.menu + "' class='mapInfo__download' target='_blank'>Download Menu</a>";
        var website = (!location.website) ? "" : "<a href='" + location.website + "' class='mapInfo__link' target='_blank'>View website</a>";
        var details = (!location.content) ? "" : "<span class='mapInfo__detailsCTA'><span class='mapInfo__detailsCTA--open' tabindex='0'>Show service details</span><span class='mapInfo__detailsCTA--close' tabindex='0'>Close service details</span></span>";
        cardLinks = "<div class='mapInfo__links'>" + email + menu + "<br/></div><div class='mapInfo__links'>" + website + details + "</div>";
        cardIcons = (!location.serviceIcons) ? "" : location.serviceIcons;
    }

    var cardDetails = (!location.content) ? "" : "<div class='mapInfo__details'>" + location.content + "</div>";

    return "<div class='mapInfo mapInfo--" + index + "'>" + cardTitle + cardContent + cardLinks + cardDetails + cardIcons + "</div>";

}

// show map cards for locations in map viewport
function showVisibleMarkers() {
    $(".mapInfo").hide();

    $.each(getVisibleMarkers(), function (index, value) {
        $(".mapInfo--" + value).css({ display: "block" });
    });

    // refresh scroller after content change
    refreshScroller();
}

// find all location in map viewport
function getVisibleMarkers() {
    var visibleMarkers = [];

    if (map !== null) {
        var viewport = map.getBounds();
        for (var i = 0; i < markers.length; i++) {
            if (viewport.contains(markers[i].marker.getPosition())) {
                visibleMarkers.push(i);
            }
        }
    }
    return visibleMarkers;
}


/******************************************************
	Map card event handlers
******************************************************/
function setupMapInfoEvents() {
    $(".mapInfo__detailsCTA--open").on("click keyup", function () {
        var openLink = $(this);
        var closeLink = openLink.siblings(".mapInfo__detailsCTA--close");

        openLink.closest(".mapInfo__links").siblings(".mapInfo__details").slideDown(400, function () {
            refreshScroller();
        });
        swapMapInfoLinks(openLink, closeLink);
    });

    $(".mapInfo__detailsCTA--close").on("click keyup", function () {
        var closeLink = $(this);
        var openLink = closeLink.siblings(".mapInfo__detailsCTA--open");

        closeLink.closest(".mapInfo__links").siblings(".mapInfo__details").slideUp(400, function () {
            refreshScroller();
        });
        swapMapInfoLinks(closeLink, openLink);
    });
}

function swapMapInfoLinks(oldLink, newLink) {
    oldLink.animate({ opacity: 0 }, 200, function () {
        setTimeout(function () {
            oldLink.hide();
            newLink.show().animate({ opacity: 1 }, 200);
        }, 50);
    });
}


/******************************************************
	Utilities
******************************************************/
// get the search location input
function getSearchAddress() {
    return $(".map__search").find("input").val() || false;
}

// get the selected search radius and map zoom level
function getSearchRadius() {
    var selected = $(".map__distance input[name='distance']:checked");
    return [parseInt(selected.val()), selected.data("zoom")];
}

// set all markers to original icon
function resetMarkerIcons() {
    for (var i = 0; i < markers.length; i++) {
        markers[i].marker.setIcon(iconURL);
    }
}

// refresh scroller after content change
function refreshScroller() {
    if (myScroll) {
        setTimeout(function () {
            myScroll.refresh();
        }, 10);
    }
}

// convert degrees to radians
function rad(x) { return x * Math.PI / 180; }
